<template>
  <div v-show="isActive" class="row align-items-center">
    <div class="col-12">
      <div class="h5 font-weight-normal text-gray-600 mb-1">{{ sumAmount }} {{ tickets_text }}</div>
      <div class="h4 mb-0">{{ sumPrice | toCurrency }} €</div>
    </div>
    <div class="col-12 text-right">
      <button class="btn btn-primary btn-lg" type="submit">
        {{ add_to_cart_text }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  filters: {
    toCurrency(value) {
      value = parseFloat(value);
      return `${value.toFixed(2)}`.replace(".", ",");
    },
  },
  props: {
    products: {
      type: Array,
      required: true,
    },
    add_to_cart_text: {
      type: String,
      required: true,
    },
    tickets_text: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      selectedProducts: "eventShow/selectedProducts",
    }),
    sumPrice() {
      return this.selectedProducts.reduce((acc, product) => {
        const foundProduct = this.products.find(p => p.master.id === product.id);
        return acc + parseFloat(foundProduct.master.price) * product.amount;
      }, 0);
    },
    sumAmount() {
      return this.selectedProducts.reduce((acc, product) => acc + product.amount, 0);
    },
    isActive() {
      return this.selectedProducts.length > 0;
    },
  },
};
</script>
